import { pdf } from '@react-pdf/renderer'

import { PlanningWorkPackDocument } from './PlanningWorkPackDocument'
import { PlanningWorkPack, WorkPackImage } from './workPackTypes'

export async function renderPlanningWorkPack(
  pack: PlanningWorkPack,
  images: WorkPackImage[]
) {
  const pageNumbers: Record<string, number> = {}
  await pdf(
    <PlanningWorkPackDocument
      pack={pack}
      images={images}
      onChapterPage={(id, page) => {
        pageNumbers[id] = page
      }}
    />
  ).toBlob()
  if (pack.chapters.some((chapter) => pageNumbers[chapter.id] === undefined))
    throw new Error(
      'Could not calculate report contents. Please retry the export.'
    )
  return pdf(
    <PlanningWorkPackDocument
      pack={pack}
      images={images}
      pageNumbers={pageNumbers}
    />
  ).toBlob()
}
